var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5265_28219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 1.16666C3.774 1.16666 1.1665 3.77416 1.1665 6.99999C1.1665 10.2258 3.774 12.8333 6.99984 12.8333C10.2257 12.8333 12.8332 10.2258 12.8332 6.99999C12.8332 3.77416 10.2257 1.16666 6.99984 1.16666ZM9.50817 9.50832C9.28067 9.73582 8.91317 9.73582 8.68567 9.50832L6.99984 7.82249L5.314 9.50832C5.0865 9.73582 4.719 9.73582 4.4915 9.50832C4.264 9.28082 4.264 8.91332 4.4915 8.68582L6.17734 6.99999L4.4915 5.31416C4.264 5.08666 4.264 4.71916 4.4915 4.49166C4.719 4.26416 5.0865 4.26416 5.314 4.49166L6.99984 6.17749L8.68567 4.49166C8.91317 4.26416 9.28067 4.26416 9.50817 4.49166C9.73567 4.71916 9.73567 5.08666 9.50817 5.31416L7.82234 6.99999L9.50817 8.68582C9.72984 8.90749 9.72984 9.28082 9.50817 9.50832Z",
    fill: "#FF4D4F",
    fillOpacity: 0.45
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5265_28219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearRed);
export default __webpack_public_path__ + "static/media/clear-red.21e59c8511e0f5c8e52a6ab94eda2e23.svg";
export { ForwardRef as ReactComponent };